__webpack_require__.p = "https://report.larrikin.club/";